/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_ActionsInputs */

const en_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Actions`)
};

const es_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones rápidas`)
};

const fr_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions rapides`)
};

const de_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellaktionen`)
};

const ja_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クイックアクション`)
};

const zh_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷操作`)
};

const ar_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجراءات سريعة`)
};

const id_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan Cepat`)
};

const it_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni Rapide`)
};

const ru_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрые действия`)
};

const pt_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações Rápidas`)
};

const ko_quick_actions = /** @type {(inputs: Quick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빠른 실행`)
};

/**
* | output |
* | --- |
* | "Quick Actions" |
*
* @param {Quick_ActionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const quick_actions = /** @type {((inputs?: Quick_ActionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_ActionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quick_actions(inputs)
	if (locale === "es") return es_quick_actions(inputs)
	if (locale === "fr") return fr_quick_actions(inputs)
	if (locale === "de") return de_quick_actions(inputs)
	if (locale === "ja") return ja_quick_actions(inputs)
	if (locale === "zh") return zh_quick_actions(inputs)
	if (locale === "ar") return ar_quick_actions(inputs)
	if (locale === "id") return id_quick_actions(inputs)
	if (locale === "it") return it_quick_actions(inputs)
	if (locale === "ru") return ru_quick_actions(inputs)
	if (locale === "pt") return pt_quick_actions(inputs)
	return ko_quick_actions(inputs)
});